import * as React from 'react';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';

const SimpleAlert = ({textMessage}) => {
  return (
    <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
      {textMessage}
    </Alert>
  );
}

export default SimpleAlert